/** Tiempos del cierre de sesión por inactividad y del polling del estado del token. */
export const SESSION_TIMING = {
  /** Sin interacción del cliente durante este tiempo, la sesión se cierra. */
  inactivityLimitMs: 60 * 60_000,
  /** Cada cuánto se compara la última interacción contra el reloj: la salida llega como mucho este tiempo tarde. */
  idleCheckMs: 30_000,
  /** Cada cuánto se consulta el estado del token. */
  pollIntervalMs: 60_000,
  /** Como mucho una interacción anotada por segundo: `pointermove` y `scroll` disparan cientos. */
  activityThrottleMs: 1_000,
} as const;
